<template>
	<div>
		<headdv :headTitle="headTitle" :isBackShow="true" :goPath="goPatHead" :activeWebTitle = 'activeWebTitle'></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<headdv2 
					@tapAddFun="addManager" 
					@SearchFun="SearchFun" 
					@allDelFun="allDelFun"  
					@condition1="condition1" 
					@condition3="condition3" 
					
					@condition9="condition9"
					@tapRecommendFun="condition6"
					@searClassFun="searClassFun"
					@condition11="condition11"
					@tapTime2Fun="tapTime2Fun"
					:headData="headData" 
					:dataClassify="dataClassify">
				</headdv2>
				<div class="content">
					<el-table :data="accountList" header-row-class-name="headrow" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column type="index" label="#"></el-table-column>
						<el-table-column prop="id" label="小说ID" width="80"></el-table-column>
						<el-table-column prop="cover" label="封面" width="100">
							<template slot-scope="scope">
								<img :src="scope.row.cover" alt style="width: 40px;height: 40px" />
							</template>
						</el-table-column>

						<el-table-column prop="title" label="小说标题" min-width="200" height="80" show-overflow-tooltip>
							<template slot-scope="scope">
								<p class="tiaozhuan_play p_height shenglue" @click="tiaozhuan_play(scope.row)">{{scope.row.title}}</p>
							</template>
						</el-table-column>
						<el-table-column prop="brief_introduction" label="简介" min-width="180" show-overflow-tooltip></el-table-column>
						<el-table-column prop="classify" label="分类名称" width="80"></el-table-column>
						<el-table-column prop="author" label="作者" width="100"></el-table-column>
						<el-table-column prop="is_deleted" label="是否下架" width="100" :formatter="formatter_is_deleted"></el-table-column>
						<el-table-column prop="status" label="连载状态" width="100" :formatter="formatter_n_serial_status"></el-table-column>
						<el-table-column prop="is_recommend" label="是否推荐" width="100" :formatter="formatter_n_manual"></el-table-column>
						<el-table-column prop="new_catalog" label="最新章节" width="180"></el-table-column>
						<el-table-column	prop="yuedu_num"	label="阅读量"		min-width="120"></el-table-column>
						<el-table-column	prop="search_num"	label="搜索量"		min-width="120"></el-table-column>
						<el-table-column	prop="fabulous"	label="收藏量"		min-width="120"></el-table-column>
						<!-- <el-table-column	prop="n_pop_num"	label="人气值"		min-width="120"></el-table-column>
						<el-table-column	prop="n_finish_num"	label="完本榜值"		min-width="120"></el-table-column> -->
						
						<!-- <el-table-column prop="head_title" label="SEO标题" min-width="200" height="80" show-overflow-tooltip>
							<template slot-scope="scope">
								<p class="tiaozhuan_play p_height shenglue" @click="tiaozhuan_play(scope.row)">{{scope.row.head_title}}</p>
							</template>
						</el-table-column>
						<el-table-column prop="head_keywords" label="SEO关键字" min-width="180" show-overflow-tooltip></el-table-column>
						<el-table-column prop="head_description" label="SEO描述" min-width="180" show-overflow-tooltip></el-table-column> -->
						<el-table-column prop="pc_web" label="来源" min-width="180"></el-table-column>
						<el-table-column prop="new_update_time" label="更新时间" width="180" :formatter="formatter_time"></el-table-column>
						<el-table-column prop="release_time" label="添加时间" width="180" :formatter="formatter_time"></el-table-column>
						<el-table-column	prop="dpv"	label="当天pv"		min-width="120"></el-table-column>
						<el-table-column	prop="duv"	label="当天uv"		min-width="120"></el-table-column>
						<el-table-column	prop="wpv"	label="周pv"		min-width="120"></el-table-column>
						<el-table-column	prop="wuv"	label="周uv"		min-width="120"></el-table-column>
						<el-table-column	prop="hpv"	label="月pv"		min-width="120"></el-table-column>
						<el-table-column	prop="huv"	label="月uv"		min-width="120"></el-table-column>
						<el-table-column	prop="spv"	label="季pv"		min-width="120"></el-table-column>
						<el-table-column	prop="suv"	label="季uv"		min-width="120"></el-table-column>
						<el-table-column	prop="ypv"	label="年pv"		min-width="120"></el-table-column>
						<el-table-column	prop="yuv"	label="年uv"		min-width="120"></el-table-column>

						<el-table-column label="操作"  width="200" fixed="right">
							<template slot-scope="scope">
								<el-button	class="edit"	size="small"	type="text"	icon="iconfont el-icon-view"	@click="allChapter(scope.row)"	>所有章节</el-button>
								<el-button	class="edit"	size="small"	type="text"	icon="iconfont icon-zhongxinshuru"	@click="editTangChuan(scope.row)"	>编辑</el-button>
								<!-- <el-button size="small"	type="text"	icon="iconfont icon-qingchujiaose"	@click.native.prevent="handleDeleteClick(scope.row)"	>删除</el-button> -->
							</template>
						</el-table-column>
					</el-table>
				</div>
				
				<!--分页-->
            	<page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		<!-- 编辑/添加 -->
		<el-dialog :visible.sync="dialogVisible" width="920px" class="dialog" :close-on-click-modal="false">
			<div class="dialog-title" slot="title">{{isEditOrAdd?'修改':'添加'}}</div>
			<!-- 内容区 start-->
			<el-form ref="staffForm" :rules="rules" :model="staffForm" label-width="100px">
				<el-form-item label="标题:" prop="title">
					<el-input v-model="staffForm.title" placeholder="请输入标题"></el-input>
				</el-form-item>
				<!-- <el-form-item label="SEO标题:" rop="head_title">
					<el-input v-model="staffForm.head_title" placeholder="例：{strNovelTitle}最新章节列表_{strNovelTitle}最新章节目录_{strWebName}"></el-input>
				</el-form-item>
				<el-form-item label="SEO关键字:" rop="head_keyword">
					<el-input type="textarea" v-model="staffForm.head_keyword" placeholder="例：{strNovelTitle},最新章节,章节列表,{strNovelTitle},最新章节,目录,{strWebName}"></el-input> 
				</el-form-item>
				<el-form-item label="SEO描述:" rop="head_description">
					<el-input type="textarea" v-model="staffForm.head_description" placeholder="例：{strNovelTitle}************;*************{strNovelTitle};*************{strWebName}"></el-input> 
				</el-form-item> -->
				<el-form-item label="简介:" prop="brief_introduction">
					<editor-bar v-model="staffForm.brief_introduction"  :isClear="isClear"  @change="change"></editor-bar>
				</el-form-item>
				<el-form-item label="作者:" prop="author">
					<el-input v-model="staffForm.author" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="来源:" prop="pc_web">
					<el-input v-model="staffForm.pc_web" placeholder="请输入来源"></el-input>
				</el-form-item>
				<el-form-item label="最新章节:" prop="new_catalog">
					<el-input v-model="staffForm.new_catalog" placeholder="请输入最新章节"></el-input>
				</el-form-item>
				<el-form-item label="最新章节ID:" prop="new_catalog_id">
					<el-input v-model="staffForm.new_catalog_id" placeholder="请输入最新章节"></el-input>
				</el-form-item>
				<el-form-item label="封面地址:" prop="over">
					<el-input v-model="staffForm.cover" placeholder="请输上传封面"></el-input>
				</el-form-item>
				<!-- <el-form-item label="假阅读数:" prop="FalseReading">
					<el-input v-model="staffForm.FalseReading" placeholder="请输入假阅读数"></el-input>
				</el-form-item> -->
				<el-form-item label="分类ID:" prop="classid">
					<template>
						<el-select v-model="staffForm.classid" placeholder="请选择" >
						<el-option v-for="item in dataClassify" :key="item.id" :label="item.name" :value="item.id">
							<span style="float: left">{{ item.name }}</span>
						</el-option>
						</el-select>
					</template>
				</el-form-item>
				<!-- <el-form-item label="推荐等级:" prop="classify">
					<template>
						<el-select v-model="staffForm.classify" placeholder="请选择" >
						<el-option v-for="item in dataClassify" :key="item.id" :label="item.name" :value="item.id">
							<span style="float: left">{{ item.name }}</span>
							<span style="float: right; color: #8492a6; font-size: 13px">{{ item.id }}</span>
						</el-option>
						</el-select>
					</template>
				</el-form-item> -->
				
				<el-form-item label="连载状态：" prop="status">
					<el-switch v-model="staffForm.status" inactive-text="连载中" active-text="已完结" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
				<el-form-item label="是否下架：" prop="is_deleted">
					<el-switch v-model="staffForm.is_deleted" inactive-text="否" active-text="是" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
				<el-form-item label="是否推荐：" prop="is_recommend">
					<el-switch v-model="staffForm.is_recommend" inactive-text="否" active-text="是" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
				
				<el-form-item prop="filePic" class="shipin_tuoru-kk">
                    <el-upload class="upload-demo" multiple name="file" drag ref="upload" action="string"
                        :on-change="handlechange_filePic" :file-list="fileList" :auto-upload="false"                  
                        :limit="1"
                        :on-remove="handleRemove_filePic" list-type="text">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将要
                            <em>上传的封面</em>拖到此处，或
                            <em>点击此处从文件里选择</em>
                        </div>
                        <div class="el-upload__text">
                            <em>封面文件必须拖入框框内</em>
                        </div>
                    </el-upload>
                </el-form-item>  
				<el-form-item label="上传进度:" prop="ac_force_update">
					<el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
					<p class="percentageStatus">{{percentageStatus}}</p>
				</el-form-item>
				
				
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="sendRequest" type="danger">文件点击上传</el-button>  
				<el-button @click="resetForm('staffForm')">取 消</el-button>
				<el-button type="primary" @click="saveForm('staffForm')">保 存</el-button>
			</span>
		</el-dialog>

		<!-- 批量修改 -->
		<el-dialog :visible.sync="statusVisible" width="650px" class="dialog">
			<div class="dialog-title" slot="title">批量上修改：</div>
			<!-- 内容区 start-->
			<el-form   label-width="100px">
				<el-form-item label="上下架：" prop="u_status">
					<el-switch v-model="u_status" inactive-text="下架" active-text="上架" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="statusVisible=false">取 消</el-button>
				<el-button type="primary" @click="updataStatus()">保 存</el-button>
			</span>
		</el-dialog>
		
		<!-- 删除 -->
		<el-dialog :visible.sync="delDate.status" width="400px" class="dialog">
			<div class="dialog-title" slot="title">删除部门/权限</div>
			<!-- 内容区 start-->
			<span>确定删除该部门/权限?</span>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="delDate.status=false">取 消</el-button>
				<el-button type="primary" @click="allDeleteEvent">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			// 新富文本编辑器
			isClear: false,
				editor: {
				info: "",
			},
			headData:{
				search_placeholder:'请输入书名',
				add:true,
				search:true,
				del:false,
				condition1:false,
				condition2:false,
				condition3:true,
				condition4:false,
				condition5:false,
				condition6:true,
				condition8:false,
				condition9:true,
				condition11:true,
			},
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			activeWebTitle:'设置',
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 7, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			u_reboot:0, //是否为机器用户 0否 1是
			u_status:0, //批量上下架     0:下架 1:上架
			multipleSelection: [],      //操作多选的数据---   左边勾选的框都会显示在这个数组中
			statusVisible:false,
			delarr: [], //存放删除的数据
			//删除弹窗
			delDate: {
				title: "删除账号",
				label: "删除数据不可恢复，确定删除？",
				status: false,
			},
			//分组id
			problemArrId_type: [],
			accountList: [], //列表数据
			checkedList: [], //选中的绑定值
			headTitle: "员工管理",
			goPatHead: "settings",
			dialogVisible: false,   //开启验证
			isEditOrAdd: false, //判断是添加还是编辑，true为编辑/false为添加
            //修改编辑的数据
			staffForm: {
				id:'',
				title: "",
				classid: "",
				status: '',
				pc_web: "",
				cover: "",
				brief_introduction:'',
				new_catalog:'',
				new_catalog_id:'',
				// head_title:'',
				// head_keyword:'',
				// head_description:'',
				//FalseReading:'',
				author:'',
				is_recommend:'0',
				is_deleted:'0',
				//n_manual_time:''
			},
			//验证规则
			rules: {
				title: [{ required: true, message: "请输入小说标题", trigger: "blur" },],
				author: [{ required: true, message: "请输入作者", trigger: "blur" },],
				origin: [{ required: true, message: "请输入小说来源格式错误", trigger: "blur" },],
				classid: [{ required: true, message: "请输选择分类ID", trigger: "blur" }],
				cover: [{ required: true, message: "请上传封面地址", trigger: "blur" }],
				status: [{ required: true, message: "请选择上下架状态", trigger: "blur" }],
				status: [{ required: true, message: "请选择连载状态", trigger: "blur" }],
				new_catalog: [{ required: true, message: "请输入最新章节", trigger: "blur" },],
				new_catalog_id: [{ required: true, message: "请输入最新章节ID", trigger: "blur" },],
				brief_introduction: [{ required: true, message: "请输入小说简介", trigger: "blur" },],
			},
			//分类数据
			dataClassify:[
				{id:1,name:'玄幻小说'},{id:2,name:'修真小说'},{id:3,name:'都市小说'},{id:4,name:'历史小说'},{id:5,name:'网游小说'},{id:6,name:'科幻小说'},
    			{id:7,name:'言情小说'},{id:8,name:'其他小说'},{id:9,name:'穿越小说'},{id:10,name:'恐怖小说'}
			],   
			fileList: [],               //app文件
			percentage:0,              //进度条
			percentageStatus:'准备上传',//上传状态
			searchVal:'',   //搜索
			old_n_manual:'',
			searchData:{
				n_addtime_start:'', //发布开始时间,时间戳
				n_addtime_end:'',   //发布结束时间,时间戳
				order:'id',            //id:默认id;ypv:阅读量倒叙;search_num:搜索量倒叙;fabulous:收藏量倒叙
				is_recommend:'',        //是否推荐;0否 1是
				classid:'',           //分类ID
				status:'',        //更新状态
				is_deleted:'0'     //是否上架;0否 1是
			}
		};
	},
	created() {
		//this.getclasslist_arrid();
		this.getclasslist();
	},
	methods: {
		//删除封面
        handleRemove_filePic(file) {
            this.fileList = [];
        },
        //选取要上传的封面后 
        handlechange_filePic(file, fileList) {
            let value = fileList[0];
            this.fileList.push(value.raw);
            this.fileList = fileList;
        },
        //点击添加里更换封面的按钮事件
        sendRequest() {
			//先判断 ，如果这个变量为空，说明没有选择本地资源，弹窗提示先选择内容
            if (this.fileList.length == 0) {
                this.$message("文件不能为空，请选择要上传的文件"); 
                return false
            } 
			let _this = this
			let percentageNum = 0
			this.percentageStatus = '正在努力上传中。。'
			let percentageTime = setInterval(() => {
				if(percentageNum<99){
					percentageNum++
					this.percentage = percentageNum
				}else{
					clearInterval(percentageTime)
				}
			},100)
            //上传文件的参数  格式
            let fd = new FormData();
            fd.append("item", 'novel');                  //根据接口文档  填写的标识  比如 要上传图片：就是img   视频就是video  联系我们contact  这个得看借口文档
            fd.append("file", this.fileList[0].raw);      //从本地选择好的文件
            fd.append("time", this.common.time);
            fd.append("platform", this.common.platform);
            fd.append("version", this.common.version);          
            //定义好参数后，发送请求，将文件资源发送给服务器，成功后 会返回资源链接
            this.https(this.apiList.upload, fd).then(response => {
                if (response.data.code == this.common.code) {
					this.percentageStatus = '上传成功'
					clearInterval(percentageTime)
					this.percentage = 100
                    this.staffForm.n_cover = response.data.data[0].path
                    let path = response.data.data[0].path          //返回的资源链接
                    this.staffForm.n_cover = path         //将返回的资源链接  赋值给input 输入框，，显示出来
                    this.tc_element(response.data.msg,response.data.code,2,"添加文件")   //成功的提示
                    this.fileList = [];    //完成后 清空数据
                }
            })
        },
		change(val) {
		     console.log("val", val);
		     //this.tgmsg = val;  //这里将获取到的值  赋值给 对应得变量
	    },
		//跳转所有章节
		allChapter(item){
			console.log(item)
			this.$router.push({name:'chapter',query: {id:item.n_id}})
		},
		//批量修改状态  保存
		updataStatus(){
			let ids = ''
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				if(ids == ''){
					ids = this.multipleSelection[i].n_id
				}else{
					ids = ids + ',' + this.multipleSelection[i].n_id
				}
			}
			let fromData = {
				n_id:ids,
				n_status:this.u_status,
			}
			this.https(this.apiList.updatenovel, fromData).then(
				(response) => {
				if (response.data.code == this.common.code){
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "批量修改");
				}
				this.statusVisible = false; //隐藏提示框
				}
			);
		},
		//格式化是否推荐
		formatter_n_manual(row, column, cellValue, index) {
			if (cellValue == 1) {
					return "是";
			} else {
					return "否";
			}
		},
		//格式化内容--时间
		formatter_time(row, column, cellValue, index) {
			let time = this.gettime.format(cellValue*1000,3) 
			return time;
		},
		//格式化内容--性别
		formatter_u_sex(row, column, cellValue, index) {
			if (cellValue == 1) {
					return "男";
			} else {
					return "女";
			}
		},
		//格式化内容--是否下架状态 1 下架 0 上架
		formatter_is_deleted(row, column, cellValue, index){
			if (cellValue == 1) {
					return "是";
			} else {
					return "否";
			}
		},
		//格式化内容--连载状态 0 连载中 1 已完结
		formatter_n_serial_status(row, column, cellValue, index){
			if (cellValue == 1) {
					return "已完结";
			} else {
					return "连载中";
			}
		},
		//格式化内容--部门		
		formatter_ar_id(row, column, cellValue, index) {
			for (let i = 0; i < this.problemArrId_type.length; i++) {
				if (cellValue == this.problemArrId_type[i].ar_id) {
					return this.problemArrId_type[i].ar_name;
				}
			}
		},

		
		//返回
		goBack() {
			this.$router.go(-1);
		},
		//获取分类数据
		getclasslist_arrid() {
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}`;
			this.https(this.apiList.getNovelClassList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
					let obj = {
						id:'',
						name:'全部'
					}
					this.dataClassify.push(obj)
					response.data.data.rows.forEach((item) => {
						if(item.nc_pid != 0){
							item['id'] = item.nc_id
							item['name'] = item.nc_name
							this.dataClassify.push(item)
						}
					});
				// this.dataClassify = response.data.data.rows; //列表数据
				console.log(this.dataClassify)
				}
			});
		},
		//获取小说列表数据
		getclasslist() {
			this.is_ok = false; //控制帅选请求 一个一个来     
			let get = `?pagesize=${this.pageData.pagesize}\n`+ 
					`&pageindex=${this.pageData.pageindex}\n`+
					`&classid=${this.searchData.classid}\n`+ 
					`&status=${this.searchData.status}\n`+ 
					`&is_deleted=${this.searchData.is_deleted}\n`+ 
					`&is_recommend=${this.searchData.is_recommend}\n`+ 
					`&order=${this.searchData.order}\n`+ 
					`&key=${this.searchVal}`    
			this.https(this.apiList.getnovellist + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
					this.accountList = response.data.data.data; //列表数据
					this.pageData.pagecount = response.data.data.total_page; //总页数
					this.pageData.count = response.data.data.total; //总条数
					this.accountList.forEach((item) => {
						item.cover = process.env.VUE_APP_COVER_PATH + item.cover
					})
				}
			});
		},
		// 点击添加按钮
		addManager() {
			for(let key in this.staffForm){
				if(key == 'n_serial_status' || key == 'n_status'){
					this.staffForm[key] = 0
				}else{
					this.staffForm[key] = ''
				}
			}
			this.dialogVisible = true;
			this.isEditOrAdd = false;
		},
		//添加--的确定
		createAccount() {
			let fromData = {}
			for(let key in this.staffForm){
				if(key !='id'){
					fromData[key] = this.staffForm[key]
				}
			}	
			//fromData.n_update_time = Date.parse(new Date())/1000
			this.https(this.apiList.addnovel, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					for(let key in this.staffForm){
						this.staffForm[key] = ''
					}
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "添加");
				}
				this.dialogVisible = false; //隐藏提示框
				}
			);
		},
		
		//点击编辑事件   显示修改弹窗
		editTangChuan(row) {
			this.old_n_manual = row.is_deleted
			console.log('1',this.old_n_manual)
			this.dialogVisible = true;
			this.isEditOrAdd = true;
			for(let key in this.staffForm){
				this.staffForm[key] = row[key]
			}	
		},
		//编辑弹窗   确定按钮
		createAccount_bianji() {
			let fromData = {}
			for(let key in this.staffForm){
				fromData[key] = this.staffForm[key]
			}
			// console.log('2',fromData.n_manual)	
			// console.log('11',this.old_n_manual)	
			// if(fromData.n_manual != this.old_n_manual)  fromData.n_manual_time = Date.parse(new Date())/1000
			// fromData.n_update_time = Date.parse(new Date())/1000
			this.https(this.apiList.updatenovel,fromData).then((response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					//弹窗提示
					this.tc_element(	response.data.msg,	response.data.code,	2,	"编辑");
				}
				this.dialogVisible = false;
			});
		},
		//点击删除按钮  的点击事件
		handleDeleteClick(row) {
			this.delDate.status = true;
			const id = row.n_id;
			this.delarr.push(id);
		},
		//点击批量删除按钮  的点击事件
		AllDeleteClick(row) {
			this.delDate.status = true;
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				this.delarr.push(this.multipleSelection[i].n_id);
			}
		},
		//点击删除弹窗的确定按钮
		allDeleteEvent() {
			let fromData = {
				n_id : this.delarr[0],
			}
			this.https(this.apiList.deletenovel, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					if (this.accountList.length <= 1) {
					if (this.pageData.pageindex == 1) {
						this.pageData.pageindex = 1;
					} else {
						this.pageData.pageindex--;
					}
					}
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "删除数据");
				}
				this.delDate.status = false; //隐藏提示框
				this.delarr = [];
				}
			);
		},
		// 保存
		saveForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 校验通过
					
					this.dialogVisible = false;
					if (this.isEditOrAdd) {
						//  编辑
						this.createAccount_bianji()
					} else {
						//  添加
						this.createAccount()
					}
				} else {
					//验证失败
					console.log("error submit!!");
					return false;
				}
			});
		},
		//编辑/添加--取消
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false;
		},
		//删除-取消
		deleteRow() {
			this.delDate.status = false;
		},
		

		//头部组件促发的方法
        //添加
        tapAddFun(){
            this.isShowAddForm = true
        },
        //搜索方法
        SearchFun(data){
			console.log(data)
			this.searchVal = data
			this.getclasslist()
        },
        //批量删除
        allDelFun(){
           console.log('del')
        },
        //条件筛选1---批量修改
        condition1(){
			this.statusVisible = true
            console.log('批量修改')
        },
        //条件筛选2
        condition2(){
            console.log('condition2')
        },
        //条件筛选--搜索
        searClassFun(val){
			cosole.log(val)
            this.searchData.classid = val
			this.getclasslist()
        },
		//条件筛选3--分类
        condition3(val){
			console.log(val)
            this.searchData.classid = val
			this.getclasslist()
        },
        //条件筛选4
        condition4(){
            console.log('condition4')
        },
        //条件筛选5
        condition5(){
            console.log('condition5')
		},
		//是否推荐
		condition6(val){
			this.searchData.is_recommend = val
			this.getclasslist()
		},
		//排序
		condition9(val){
			this.searchData.order = val
			this.getclasslist()
		},
		//上下架
		condition11(val){
			this.searchData.is_deleted = val
			this.getclasslist()
		},
		//时间筛选
		tapTime2Fun(arr){
			this.searchData.n_addtime_start = arr[0]/1000
			this.searchData.n_addtime_end = arr[1]/1000
			this.getclasslist()
		},
		
        //分页
		//pageSize 改变时会触发    每页条数
		handleSizeChange(val) {
			console.log(val)
			this.pageData.pagesize = val 
			this.getclasslist();
		},
		//currentPage 改变时会触发     当前页
		handleCurrentChange(val) {
			console.log(val)
			this.pageData.pageindex = val
			this.getclasslist();
		},
        //取消删除--子组件促发
        cancelDel(){
            this.delDate.status = false;
        },
        //确定删除--子组件促发
        determineDel(){
            //this.allDeleteEvent()
		  },
			//操作多选  --获取多选的内容
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		  
			//格式化内容--是否会员
			formatter_u_isvip(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "是";
					} else {
						return "否";
					}
			},
			//格式化内容--是否为代理商
			formatter_u_is_agent(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "是";
					} else {
						return "否";
					}
			},
			//格式化内容--是否会员
			formatter_u_status(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "正常";
					} else {
						return "禁用";
					}
			},
	},
};
</script>
<style lang="scss" scoped>
::v-deep .el-textarea .el-textarea__inner {
	min-height: 100px!important;
}
::v-deep .el-textarea{
	width:760px;
}
::v-deep .el-progress {
    margin-top: 7px;
}
.percentageStatus{
	position:absolute;
	left:50%;
	top:50%;
	transform: translate(-50%,-50%);
	color:#ccc;
}
::v-deep .text {
    min-height: 150px;
}
// 表格样式
::v-deep .el-table {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    // flex-direction: row;
    // align-items: center;
    // justify-content: center;
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left: 25px;
    }
  }
}
</style>